import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { TrendingUp, Filter } from 'lucide-react';
import ContentGrid from '../components/common/ContentGrid';
import { demoPosts, demoArticles, demoVideos } from '../data/demoData';
import { useShare } from '../hooks/useShare';

const timeRanges = ['Today', 'This Week', 'This Month', 'All Time'];
const categories = ['All', 'Technology', 'Business', 'Development', 'AI'];

export default function TrendingPage() {
  const { theme } = useTheme();
  const handleShare = useShare();
  const [timeRange, setTimeRange] = useState('Today');
  const [category, setCategory] = useState('All');

  // Combine and sort content by views
  const trendingContent = [...demoPosts, ...demoArticles, ...demoVideos]
    .sort((a, b) => b.views - a.views)
    .filter(content => 
      category === 'All' || 
      (content.type === 'article' && content.category === category) ||
      (content.type === 'video' && content.category === category)
    );

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <TrendingUp className="h-8 w-8 text-blue-500" />
          <h1 className={`text-2xl font-bold ${
            theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
          }`}>
            Trending
          </h1>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-4">
        <select
          value={timeRange}
          onChange={(e) => setTimeRange(e.target.value)}
          className={`
            px-4 py-2 rounded-lg border focus:ring-2 focus:ring-blue-500 focus:outline-none
            ${theme === 'dark'
              ? 'bg-gray-800 border-gray-700 text-gray-100'
              : 'bg-white border-gray-200 text-gray-900'
            }
          `}
        >
          {timeRanges.map(range => (
            <option key={range} value={range}>{range}</option>
          ))}
        </select>

        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className={`
            px-4 py-2 rounded-lg border focus:ring-2 focus:ring-blue-500 focus:outline-none
            ${theme === 'dark'
              ? 'bg-gray-800 border-gray-700 text-gray-100'
              : 'bg-white border-gray-200 text-gray-900'
            }
          `}
        >
          {categories.map(cat => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>
      </div>

      <ContentGrid
        items={trendingContent}
        onLike={(id) => {
          console.log('Liked content:', id);
        }}
        onShare={async (id) => {
          const content = trendingContent.find(item => item.id === id);
          if (content) {
            await handleShare(content);
          }
        }}
      />
    </div>
  );
}